import React from "react";
import Header from "../components/Header";

function Box() {
  return (
    <div className="col-span-6 w-full md:col-span-4 lg:col-span-3">
      <div className="w-full bg-gray-100 p-2 rounded">
        <div className="w-full px-2 flex justify-between items-center">
          <p>Draft</p>
          <button className="w-7 h-7 rounded-full shadow bg-pink-500 text-white flex items-center justify-center text-lg focus:ring">
            +
          </button>
        </div>
        <div className="w-full pt-5 pb-10 text-4xl flex items-center justify-center">
          0
        </div>
      </div>
    </div>
  );
}

const DocumentsDashboard = ({ LeftNavRef }) => {
  return (
    <div className="w-full">
      <div className=" px-4 md:px-10 pb-10">
        <Header LeftNavRef={LeftNavRef} />
        <h2 className="text-lg mb-2">Documents</h2>
        <br />
        <div className="flex justify-between text-xs sm:text-base items-center">
          <button className="px-6 py-1.5 bg-pink-500 text-white rounded shadow focus:ring">
            Create new
          </button>
          <div className="flex space-x-5">
            <p>1 Week</p>
            <p>1 Month</p>
            <p>1 Year</p>
          </div>
        </div>
      </div>

      <div className="xl:max-w-screen-xl xl:mx-auto mt-5 px-2 sm:px-6 gap-2 sm:gap-5 place-items-center grid grid-cols-12">
        <Box />
        <Box />
        <Box />
        <Box />
        <Box />
        <Box />
        <Box />
        <Box />
        <Box />
        <Box />
        <Box />
        <Box />
        <Box />
        <Box />
        <Box />
      </div>
    </div>
  );
};

export default DocumentsDashboard;
